// extracted by mini-css-extract-plugin
module.exports = {"input":"input-button_input__z4pKT","error":"input-button_error__tPwW4"};